<template>
  <!-- Projects Modal -->
  <div class="modal fade" id="scrapingModal" tabindex="-1" aria-labelledby="scrapingModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="scrapingModalLabel">資料擷取與分析系統</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <!-- 專案概述 -->
          <div class="mb-4 mx-4">
            <h5 class="fw-bold"><i class="bi bi-info-circle"></i> 專案概述</h5>
            <p>自動化網路資料收集與處理系統，能夠自動擷取網頁資料、下載相關圖片，並產生結構化的 Excel 報表，大幅提升資料收集效率。</p>
          </div>

          <!-- 主要功能 -->
          <div class="mb-4 mx-4">
            <h5 class="fw-bold"><i class="bi bi-stars"></i> 主要功能</h5>
            <div class="row g-3 align-items-center">
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <h6 class="card-title"><i class="bi bi-globe"></i> 網站資料擷取</h6>
                    <div class="d-flex align-items-center justify-content-center">
                      <ul class="list-unstyled text-start">
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>多網頁同時爬取</li>
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>自動處理編碼問題</li>
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>支援動態網頁爬取</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <h6 class="card-title"><i class="bi bi-file-earmark-excel"></i> 輸出成 Excel 或網頁</h6>
                    <div class="d-flex align-items-center justify-content-center">
                      <ul class="list-unstyled text-start">
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>自動格式化表格</li>
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>多工作表整合</li>
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>自動統計與分析</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <h6 class="card-title"><i class="bi bi-images"></i> 圖片下載處理</h6>
                    <div class="d-flex align-items-center justify-content-center">
                      <ul class="list-unstyled text-start">
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>批量圖片下載</li>
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>自動分類儲存</li>
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>圖片命名優化</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="card h-100">
                  <div class="card-body">
                    <h6 class="card-title"><i class="bi bi-gear"></i> 系統特色</h6>
                    <div class="d-flex align-items-center justify-content-center">
                      <ul class="list-unstyled text-start">
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>異常處理機制</li>
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>進度監控回報</li>
                        <li><i class="bi bi-check-circle-fill text-success me-2"></i>資源使用優化</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 技術實現 -->
          <div class="mb-4">
            <h5 class="fw-bold"><i class="bi bi-code-square"></i> 技術實現</h5>
            <div class="bg-light p-3 rounded">
              <div class="row">
                <div class="col-md-6">
                  <h6 class="fw-bold">核心技術</h6>
                  <div class="d-flex flex-wrap gap-2 mb-3 justify-content-center">
                    <span class="badge bg-primary">Python</span>
                    <span class="badge bg-primary">Selenium</span>
                    <span class="badge bg-primary">BeautifulSoup4</span>
                    <span class="badge bg-primary">Pandas</span>
                    <span class="badge bg-primary">Requests</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <h6 class="fw-bold">資料處理</h6>
                  <div class="d-flex flex-wrap gap-2 justify-content-center">
                    <span class="badge bg-secondary">Excel 處理</span>
                    <span class="badge bg-secondary">資料清理</span>
                    <span class="badge bg-secondary">多執行緒</span>
                    <span class="badge bg-secondary">非同步處理</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 效益展示 -->
          <div class="mb-4">
            <h5 class="fw-bold"><i class="bi bi-graph-up"></i> 系統效益</h5>
            <div class="row g-3">
              <div class="col-md-4">
                <div class="border rounded p-3 text-center">
                  <h3 class="text-primary">90%</h3>
                  <p class="mb-0">工作時間節省</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="border rounded p-3 text-center">
                  <h3 class="text-primary">100%</h3>
                  <p class="mb-0">資料準確度</p>
                </div>
              </div>
              <div class="col-md-4">
                <div class="border rounded p-3 text-center">
                  <h3 class="text-primary">24/7</h3>
                  <p class="mb-0">自動化運作</p>
                </div>
              </div>
            </div>
          </div>

          <!-- 應用場景 -->
          <div>
            <h5 class="fw-bold"><i class="bi bi-briefcase"></i> 應用場景</h5>
            <ul class="list-unstyled">
              <li><i class="bi bi-check2-circle text-success me-2"></i>電商價格監控</li>
              <li><i class="bi bi-check2-circle text-success me-2"></i>新聞資訊收集</li>
              <li><i class="bi bi-check2-circle text-success me-2"></i>產品資訊整理</li>
              <li><i class="bi bi-check2-circle text-success me-2"></i>市場數據分析</li>
            </ul>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">關閉</button>
        </div>
      </div>
    </div>
  </div>
</template>
